export default "__VITE_ASSET__BAuIFaxY__"